import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../theme';
import type { Icons } from '../../assets';

export type IconColorVariants =
    | 'bright'
    | 'basic'
    | 'third'
    | 'disabled'
    | 'danger'
    | 'colored'
    | 'white'
    | 'black'
    | 'transparent';

export interface IconProps {
    icon: Icons;
    /**
     * @deprecated Use props 'colors' instead. The colors for the icon can be any from the entire palette.
     */
    colorVariant?: IconColorVariants;
    /**
     * @deprecated Use props 'strokeColor' instead. The stroke colors for the icon can be any from the entire palette.
     */
    strokeColorVariant?: IconColorVariants;
    color?: string;
    strokeColor?: string;
    className?: string;
    style?: React.CSSProperties;
    ref?: React.RefObject<SVGSVGElement>;
    width?: number;
    height?: number;
    size?: number;
    cy?: string;
}

export const Icon: React.FC<IconProps> = ({
    icon,
    strokeColor,
    className,
    strokeColorVariant,
    colorVariant,
    color,
    cy,
    ...props
}) => {
    const theme = useTheme();
    const iconName = `#${icon}`;

    const colorVariantMap: Record<IconColorVariants, string> = {
        basic: theme.root.colors.basicColors['55%'],
        bright: theme.root.colors.basicColors['90%'],
        third: theme.root.colors.basicColors['30%'],
        disabled: theme.root.colors.basicColors['25%'],
        colored: theme.root.colors.accent.textOrIcon,
        white: theme.root.colors.basicColors.white['100%'],
        black: theme.root.colors.basicColors.black['100%'],
        danger: theme.root.colors.system.dangerDefault,
        transparent: 'transparent',
    };

    const fill = color || colorVariantMap[colorVariant || 'basic'];
    const stroke = strokeColor || (strokeColorVariant ? colorVariantMap[strokeColorVariant] : undefined);

    const getIconSize = () => ({
        width: props.size || props.width || 24,
        height: props.size || props.height || 24,
    });

    const size = getIconSize();

    return (
        <svg
            fill={fill}
            stroke={stroke}
            style={{
                ...size,
                display: 'block',
            }}
            className={className}
            data-cy={cy}
            {...size}
        >
            <use href={iconName} />
        </svg>
    );
};

// eslint-disable-next-line @typescript-eslint/ban-types
export default styled(Icon)<{}>``;
